import { useRecordContext, useFieldValue } from 'react-admin';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import { useTheme } from '@mui/material/styles';

const StyledRating = styled(Rating)(({ value }) => {
    const theme = useTheme();

    let color;
    if (value > 3) {
        color = theme.palette.mode === 'dark' ? theme.palette.success.main : theme.palette.success.light;
    }
    else if (value === 3) {
        color = theme.palette.mode === 'dark' ? theme.palette.warning.main : theme.palette.warning.light;
    }
    else {
        color = theme.palette.mode === 'dark' ? theme.palette.error.main : theme.palette.error.light;
    }

    return {
        '& .MuiRating-iconFilled': {
            color,
        }
    };
});

const RatingField = ({ source, ...props }) => {
    const record = useRecordContext(props);
    const value = useFieldValue({ source, record });

    if (!record || !value) {
        return null;
    }

    return (
        <StyledRating
            icon={<HourglassFullIcon fontSize="inherit" />}
            emptyIcon={<HourglassEmptyIcon fontSize="inherit" />}
            getLabelText={(value) => value}
            size="small"
            readOnly
            value={value}
            {...props}
        />
    );
};

export default RatingField;